import { useSelector } from 'react-redux';

export const useApplicationFlags = () => {
  const isOcm = useSelector((state) => state.loan.channel === 'OCM-WEB');
  const isOcmOrUpgrade = isOcm || INCREASE_APP;

  return {
    isOcmOrUpgrade,
  };
};
